import { CheckUploadFiles } from "./services/CheckUploadFile.js";

document.addEventListener("DOMContentLoaded", () => {
  try {
    new CheckUploadFiles();
  } catch (error) {
    console.error(error);
  }
});

window.$ = window.jQuery;

const navbar = document.querySelector('.navbar');
const hamburger = document.querySelector('.navbar-hamburger');
const content = document.querySelector('.navbar-nav');
let menuOpen = false;

$(hamburger).click(function () {
  if (!menuOpen) {
    navbar.classList.add('navbar--active');
    hamburger.classList.add('navbar-hamburger--active');

    setTimeout(function () {
      content.classList.add('navbar-nav--active');
    }, 500);
    menuOpen = true;
  } else {
    navbar.classList.remove('navbar--active');
    hamburger.classList.remove('navbar-hamburger--active');
    content.classList.remove('navbar-nav--active');
    menuOpen = false;
  }
});

$(function() {
  const close = $('.feather-x');
  if (close !== null) {
    close.on("click", function() {
      $('.chat').css('display', 'none');
    });
  }

  const open = $('.open-chat');
  if (open !== null) {
    open.on( "click", function() {
      $('.chat').css('display', 'initial');
    });
  }

  $('.contact-box .btn-white:not(.link)').on('click', function() {
    $(this).html('<span>E-mail copied!</span>');
  });
  $('.link').removeClass('open-chat');

  $(window).bind( 'hashchange', function() {
    hashChange();
  });

  // $('a').on('click', function () {
  //   let href = $(this).attr('href') ?? '';
  //
  //   console.log(href);
  //
  //   if ( href.indexOf('#') != -1 ) {
  //     setTimeout(() => {
  //       hashChange(href);
  //     }, "160")
  //   }
  // });

  hashChange();
});

function hashChange(id=null) {
  let url = id ?? window.location.hash;

  if (url != "") {
    let div = $(url).offset().top;
    let height = $('nav.navbar').outerHeight(true);
    let scrollTop = div - height;

    window.scrollTo(scrollTop, scrollTop);
  }
}

// NAV

naviFunctions();

$(window).resize(function () {
  naviFunctions();
});

function naviFunctions() {
  let windowWidth = $(window).width();

  if (windowWidth > 991) {
    $('#menu-item-157 > a').attr('onclick', 'window.location.href = \'/services\'');
    $('#menu-item-157 > a').attr('href', '/services');

      $('.dropdown').hover(
      function () {
        $(this).addClass('show', 200);
        $(this).find('.dropdown-menu').first().addClass('show', 200);
        $(this).find('.dropdown-toggle').first().attr('aria-expanded', "true");
      }, function () {
        $(this).removeClass('show', 200);
        $(this).find('.dropdown-menu').first().removeClass('show', 200);
        $(this).find('.dropdown-toggle').first().attr('aria-expanded', "false");
      }
    );
    $('.navbar__readmore--mobile').show();
  } else {
    $('#menu-item-157 > a').attr('href', '#');

    $('.dropdown').click(function () {
      $(this).find('.dropdown-menu').addClass('show', 200);
      $('.navbar__readmore--mobile').hide();
    });

  }
}
